// extracted by mini-css-extract-plugin
module.exports = {"label":"styles_label__vTBYn","input":"styles_input__S0Tn4","fadeInOut":"styles_fadeInOut__Gq7p0","loader":"styles_loader__x7pFS"};